var React = require('react');

function ExternalLinkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.4444 13.4444H2.55556V2.55556H6.44444V1H2.55556C2.143 1 1.74733 1.16389 1.45561 1.45561C1.16389 1.74733 1 2.143 1 2.55556V13.4444C1 13.857 1.16389 14.2527 1.45561 14.5444C1.74733 14.8361 2.143 15 2.55556 15H13.4444C14.3 15 15 14.3 15 13.4444V9.55556H13.4444V13.4444ZM9.55556 1V2.55556H12.3478L4.70222 10.2011L5.79889 11.2978L13.4444 3.65222V6.44444H15V1H9.55556Z","fill":"currentColor"}));
}

ExternalLinkInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ExternalLinkInline;

ExternalLinkInline.default = ExternalLinkInline;
